import React, { Fragment, Component } from 'react'; import DataGrid, {
    Column,
    Export, Grouping,
    GroupPanel,
    HeaderFilter, Pager,
    Paging,
    SearchPanel,
    SortByGroupSummaryInfo, MasterDetail,
} from 'devextreme-react/data-grid'; //npm i devextreme-react
import { getRequestParams,numberGridFormat } from '../../helpers/globalfunctions.js';
import { alphanumericValidation } from '../../helpers/globalvalidations.js';
import { SelectBox } from 'devextreme-react/select-box';
import Modal from 'react-modal'; //npm install --save react-modal;
import NumberBox from 'devextreme-react/number-box';
import { currencySymbolFormats, precisionFormats } from '../../helpers/fixcodes.js';
import Swal from 'sweetalert2';

const customStyles = {
    content: {
        width: '50%',
    }
}
export class BillPaymentComponent extends Component {
    static displayName = BillPaymentComponent.name;
    constructor(props) {
        super(props);
        this.state = {
            billPayment: null,
            billPaymentSummary: null,
            customerInvoice: null,
            invoicepaymentModelIsOpen: false,
            accountId: this.props.location.state === undefined ? 0 : this.props.location.state.accountId,
            accountName: this.props.location.state === undefined ? "" : this.props.location.state.accountName,
            creditAmount: 0.0,
            debitAmount: 0.0,
            dueAmount: 0.0,
            overDueAmount: 0.0,
            invoiceDueAmount :0.0,
            dueBillTotalAmount :0.0,
            billTotalAmount :0.0,
            billId: 0,
            billNo: "",
            amount: 0.0,
            balanceAmount: 0.0,
            settleAmount: 0.0,
            remarks: "",
            paymentId: 0,
            sessionUser: JSON.parse(sessionStorage.getItem("sessionUser")),
            seconds: 30,
            vendorName :'',
            vendorId:0,
            orderNumber :'',
            errors: {
                settleAmount: 0,
                billNo: "",
            }

        }
    }

    async componentDidMount() {
        await this.getBillPaymentMaster();
    }

    getBillPaymentMaster = async () => {
        try {
            const requestParams = getRequestParams("GET");
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'billPayment/' + this.state.accountId + '/0', requestParams);
            const data = await response.json();
            this.setState({
                billPayment: data.payload.billPayment,
                billPaymentSummary: data.payload.billPaymentSummary,
                creditAmount: data.payload.billPayment[0].creditAmount,
                debitAmount: data.payload.billPayment[0].debitAmount,
                dueAmount: data.payload.billPayment[0].dueAmount,
                overDueAmount: data.payload.billPayment[0].overDueAmount,
                invoiceDueAmount : data.payload.billPayment[0].dueInvoiceAmount,
                dueBillTotalAmount : data.payload.billPayment[0].dueBillTotalAmount,
                billTotalAmount :data.payload.billPayment[0].totalBillAmount
            });
        } catch (err) {
            console.log("Error in " + this.displayName + ".getBillPaymentMaster function", err);
        }
    }
    handleClear = () => {
        window.location.href = "/billpayment/list";
    }
    openInvoicePaymentModel = (e, gridData) => {
        this.setState({
            invoicepaymentModelIsOpen: true,
            paymentId: gridData.paymentId
        });
        this.getCustomerBills();
    }
    handleAmountChange = (event) => {
        const newValue = event.value;
        this.setState({ "amount": newValue });
    }
    handleBalanceAmountChange = (event) => {
        const newValue = event.value;
        this.setState({ "balanceAmount": newValue });
    }
    handleSettleAmountChange = (event) => {
        const newValue = event.value;
        this.setState({ "settleAmount": newValue });
    }
    handleInvoiceChange = (selectedOption) => {
        
        this.setState({
            billNo: (selectedOption.selectedItem !== null ? selectedOption.selectedItem.billNo : ""),
            amount: (selectedOption.selectedItem !== null ? selectedOption.selectedItem.grossAmount : ""),
            balanceAmount: (selectedOption.selectedItem !== null ? selectedOption.selectedItem.dueAmount : ""),
            vendorName: (selectedOption.selectedItem !== null ? selectedOption.selectedItem.vendorName : ""),
            vendorId :(selectedOption.selectedItem !== null ? selectedOption.selectedItem.vendorId : ""),
            orderNumber :(selectedOption.selectedItem !== null ? selectedOption.selectedItem.orderNumber : "")
        });

        if (selectedOption.selectedItem !== null && selectedOption.selectedItem.invoiceNo !== null) {
            this.state.errors["billNo"] = "";
        }

    }
    ClearModel = () => {
        this.setState({
            billId: 0,
            billNo: "",
            amount: 0.0,
            balanceAmount: 0.0,
            settleAmount: 0.0,
            remarks: "",
            invoicepaymentModelIsOpen: false,
            errors: {
                settleAmount: 0,
                billNo: "",
            }
        });
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        //const alphanumericValidation = /^[A-Za-z0-9]*$/;
        switch (name) {
            case 'remarks':
                if (alphanumericValidation.test(event.target.value))
                    this.setState({ name: event.target.value });
                break;

            default:
                this.setState({ [name]: value });
                break;
        }
        this.setState({ [name]: value });

    }
    getCustomerBills= async () => {
        try {
         
            var request = {};
            request.VendorId = 0;
            request.BillNo = "";
            request.BillStatusId = 0;
            request.BillPaymentStatus = 0;
            const requestParams = getRequestParams("POST", request);
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'billPayment/CustomerBill', requestParams);
            const data = await response.json();
            this.setState({
                customerInvoice: data.payload.filter(e => e.billStatus !== "Paid"),

            });
        } catch (err) {
            console.log("Error in " + this.displayName + ".getBillPaymentMaster function", err);
        }
    }

    handleInvoicePaymentSubmit = async (e) => {
        e.preventDefault();
        try {
            if (this.handleValidation()) {
                this.setState({ isSubmited: true });
                var request = new Object();
                request.UserId = this.state.sessionUser.id;
                request.PaymentId = this.state.paymentId;
                request.VendorId = this.state.vendorId;
                request.BillNo = this.state.billNo;
                request.AmountPaid = this.state.settleAmount;
                request.DueAmount = this.state.balanceAmount;
                request.OrderNumber = this.state.orderNumber
             
                const requestParams = getRequestParams("POST", request);
             
                const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'billPayment/billPayment', requestParams);
                const data = await response.json();
                if (data.isSuccess) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: data.message,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.getBillPaymentMaster();
                            this.ClearModel();
                        }
                        this.setState({ isSubmited: false })
                    })
                }
                this.setState({ isSubmited: false });
            }
        } catch (err) {
            console.log("Error in " + this.displayName + ".handleInvoicePaymentSubmit function", err);
        }
    }

    handleValidation = () => {
        let formIsValid = true;
        try {
            let errors = this.state.errors;
            errors.settleAmount = "";
            errors.billNo = "";

            if (this.state.settleAmount === 0) {
                formIsValid = false;
                errors.settleAmount = "Please enter settle Amount.";
            }
            if (this.state.billNo === "") {
                formIsValid = false;
                errors.billNo = "Please select bill no.";
            }
            this.setState({ errors: errors });
        }
        catch (err) {
            console.log("Error in " + this.displayName + ".handleValidation function", err);
            this.setState({ isSubmited: false })
        }
        return formIsValid;
    }
    // renderDetail(props) {
    //  
    //     return (<div><DetailTemplate
    //         useRef="dipatchDetailRef"
    //          isDispatchRowIndex={props.data.customerId}
    //          dispatchRideId={props.data.paymentId}
    //         // singleRideSource={props.data}
    //          refreshDataSource={this.getBillPaymentMaster}
    //          stopAutoRefresh={this.dispatchInterval}
    //         // stopAutoRefreshHandle={this.dispatchIntervalHandle}
    //         // isStopAutoRefresh={this.isStopAutoRefresh}
    //         // handleRefresh={this.handleRefresh}
    //         // //rowChanged={this.rowChanged}
    //         // editViewRide={this.editViewRide}
    //     /></div>);
    // }
    handleRowPrepared = (e) => {
        // 
        // if (e.rowType === 'header') {
        //     e.rowElement.style.backgroundColor = '#cce5ff';
        //   }
        if (e.rowType === 'data') {
          e.rowElement.style.backgroundColor = '#E8F5E9';
        }
    }
    render() {
        const renderGridCell = (data) => {
            return <div>
                <button type="button" className="btn btn-sm btn-success" onClick={(e) => this.openInvoicePaymentModel(e, data.data)}>
                    <span title="Pay"><small><i className="fas fa-rupee-sign"></i></small> Pay</span>
                </button>
            </div>;
        }
        const renderGridTotalAmountCell = (data) => {
          return numberGridFormat(data.value)
            //  return <div><small><i className={currencySymbolFormats.currencyFormat}></i></small>&nbsp;&nbsp;{parseFloat(data.value).toFixed(precisionFormats[2])}</div>;
        }
        return (
            <Fragment>
                <div className="section-body">
                    <div className='card bg-filter'>
                        <div className='card-body'>
                            <div className="section-header">
                                <h5 className="card-title text-blue mb-0">{this.state.accountName}</h5>
                                <div className="section-header-buttons">
                                    <button type="submit" className="btn btn-success" onClick={this.handleClear}>
                                        <span title="Cancel"><i class="fas fa-arrow-left"></i> Back</span>
                                    </button>
                                </div>
                            </div>

                           
                        </div>
                    </div>
                    <div className='card mb-2'>
                        <div className='card-body'>
                        <div className='invoice-pymt-details'>
                                <div>
                                    <label className='mb-0'>Balance Amount</label>
                                    <div className='text-blue'><h5 className='mb-0'>{parseFloat(this.state.dueAmount).toFixed(precisionFormats[2])}</h5></div>
                                    {/* <div><b>{parseFloat(this.state.creditAmount).toFixed(precisionFormats[2])}</b></div> */}
                                </div>
                                <div>
                                    <label className='mb-0'>Total Bill Amount</label>
                                    <div className='text-blue'><h5 className='mb-0'>{parseFloat(this.state.billTotalAmount).toFixed(precisionFormats[2])}</h5></div>
                                    {/* <div><b>{parseFloat(this.state.creditAmount).toFixed(precisionFormats[2])}</b></div> */}
                                </div>

                                <div>
                                    <label className='mb-0'>Total Paid Amount</label>
                                    <div><h5 className='mb-0'>{parseFloat(this.state.debitAmount).toFixed(precisionFormats[2])}</h5></div>
                                </div>
                                <div>
                                    <label className='mb-0'>Total Due Amount</label>
                                    <div><h5 className='mb-0'>{parseFloat(this.state.dueBillTotalAmount).toFixed(precisionFormats[2])}</h5></div>
                                </div>
                                {/* <div>
                                    <label className='mb-0'>Total Bill Due Payment</label>
                                    <div className='text-blue'><b>{parseFloat(this.state.dueAmount).toFixed(precisionFormats[2])}</b></div>
                                </div> */}
                                <div>
                                    <label className='mb-0'>Bill Over Due Amount</label>
                                    <div><h5 className='mb-0'>{parseFloat(this.state.overDueAmount).toFixed(precisionFormats[2])}</h5></div>
                                </div>
                            </div>                           
                        </div>
                    </div>
                    <div className='card'>
                    <div className='card-body'>
                        <div className='mt-3'>
                                <DataGrid
                                    dataSource={this.state.billPaymentSummary}
                                    keyExpr="paymentId"
                                    id='invoicepaymentList'
                                    selection={{ mode: 'single' }}
                                    columnsAutoWidth={false}
                                    showColumnLines={true}
                                    showRowLines={true}
                                    showBorders={true}
                                    rowAlternationEnabled={false}
                                    allowColumnResizing={true}
                                    onExporting={this.onExporting}
                                    onRowPrepared={this.handleRowPrepared}
                                    columnResizingMode='widget'
                                    onToolbarPreparing={this.onToolbarPreparing}>
                                    <Column dataField="accountName" caption="Account" allowSearch={true} allowFiltering={false} allowSorting={true} width={120} />
                                    <Column dataField="paymentDate" caption="Payment Date" allowSearch={true} allowFiltering={false} allowSorting={true} width={130} dataType="datetime" format="dd/MM/yyyy" />
                                    <Column dataField="paymentMode" caption="Payment Mode" allowSearch={true} allowFiltering={false} allowSorting={true} width={250} />
                                    <Column dataField="creditAmount" caption="Payment Amount" allowSearch={true} allowFiltering={false} allowSorting={true} width={200} cellRender={renderGridTotalAmountCell} />
                                    <Column dataField="transactionNo" caption="Transaction#" allowSearch={true} allowFiltering={false} allowSorting={true} width={250} />
                                    <Column dataField="paymentId" caption="" allowSearch={true} allowFiltering={false} allowSorting={true} width={100} cellRender={renderGridCell} />
                                    <MasterDetail
                                        enabled={true}
                                        component={DetailTemplate}
                                    //stopAutoRefresh={this.dispatchInterval}
                                    />
                                    <SortByGroupSummaryInfo summaryItem="count" />
                                    <GroupPanel visible={false} />
                                    {/* <Template name="toolbarTemplate" /> */}
                                    <HeaderFilter visible={true} />
                                    <SearchPanel visible={true} highlightCaseSensitive={true} width={240} placeholder="Search..." />
                                    <Grouping autoExpandAll={true} />
                                    <Paging defaultPageSize={20} />
                                    <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 50]} showInfo={true} visible={true} />
                                    {/* <Export enabled={true} allowExportSelectedData={false} fileName="Bill Payment" /> */}
                                </DataGrid>
                            </div>

                            <Modal ariaHideApp={false}
                                isOpen={this.state.invoicepaymentModelIsOpen}
                                style={customStyles}
                                className={"react-modal"}
                                //onAfterOpen={this.handleAssignDataToState}
                                onRequestClose={this.closeHsnModal}
                                shouldCloseOnOverlayClick={false}
                                contentLabel="Example Modal">
                                <form method="POST" style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                                    <div className="modal-header">
                                        <h6 className="modal-title"> New Bill Payment</h6>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label htmlFor="">Bill No <span className="text-danger">*</span></label>
                                                    <SelectBox
                                                        dataSource={this.state.customerInvoice}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        placeholder="Select bill"
                                                        name="billNo"
                                                        defaultValue={0}
                                                        value={this.state.billNo}
                                                        displayExpr='billNo'
                                                        valueExpr='billNo'
                                                        onSelectionChanged={this.handleInvoiceChange}
                                                        showClearButton={true}
                                                        // disabled={this.state.id > 0}
                                                        searchEnabled={true}
                                                    />
                                                    {this.state.errors["billNo"].length > 0 && <span className="error invalid-feedback">{this.state.errors["billNo"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label htmlFor="">Bill Amount</label>
                                                    <NumberBox type="number" className="form-control form-control-sm" name="amount" placeholder="Enter Amount"
                                                        format="#0.00" disabled={true}
                                                        defaultValue={0.00} title="amount" value={this.state.amount} onValueChanged={this.handleAmountChange} min={0.00} max={999999.99} />
                                                    {/* {this.state.errors["amountPaid"].length > 0 && <span className="error invalid-feedback">{this.state.errors["amountPaid"]}</span>} */}
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label htmlFor=""> Pending Amount</label>
                                                    <NumberBox type="number" className="form-control form-control-sm" name="balanceAmount" placeholder="Enter balance Amount"
                                                        format="#0.00" disabled={true}
                                                        defaultValue={0.00} title="balanceAmount" value={this.state.balanceAmount} onValueChanged={this.handleBalanceAmountChange} min={0.00} max={999999.99} />
                                                    {/* {this.state.errors["amountPaid"].length > 0 && <span className="error invalid-feedback">{this.state.errors["amountPaid"]}</span>} */}
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label htmlFor="">Settle Amount</label>
                                                    <NumberBox type="number" className="form-control form-control-sm" name="amount" placeholder="Enter settle Amount"
                                                        format="#0.00"
                                                        defaultValue={0.00} title="settleAmount" value={this.state.settleAmount} onValueChanged={this.handleSettleAmountChange} min={0.00} max={999999.99} />
                                                    {this.state.errors["settleAmount"].length > 0 && <span className="error invalid-feedback">{this.state.errors["settleAmount"]}</span>}
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label>Vendor </label>
                                                    <input type="text" className="form-control form-control-sm" name="vendorName" autoComplete="vendorName" placeholder="Enter Vendor" disabled={true} value={this.state.vendorName}
                                                        title="vendorName" maxLength="250" onChange={this.handleInputChange} />
                                                    {/* {this.state.errors["remarks"].length > 0 && <span className="error invalid-feedback">{this.state.errors["remarks"]}</span>} */}
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label>Remarks </label>
                                                    <input type="text" className="form-control form-control-sm" name="remarks" autoComplete="remarks" placeholder="Enter Remarks" value={this.state.remarks}
                                                        title="remarks" maxLength="250" onChange={this.handleInputChange} />
                                                    {/* {this.state.errors["remarks"].length > 0 && <span className="error invalid-feedback">{this.state.errors["remarks"]}</span>} */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="submit" className="btn btn-success" onClick={this.handleInvoicePaymentSubmit} >
                                            {this.state.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                            {!this.state.isSubmited && <span title="Submit">Submit</span>}
                                        </button>
                                        <button type="button" className="btn btn-outline-secondary" onClick={this.ClearModel} title="Cancel">Cancel</button>
                                    </div>
                                </form>
                            </Modal>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}
class DetailTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            customerId: props.data.data.accountId,
            paymentId: props.data.data.paymentId,
            billpaymentDetails: [],
        };
    }
    async componentDidMount() {
        await this.getCustomerInvoices();
    }

    getCustomerInvoices = async () => {
        try {
            const requestParams = getRequestParams("GET");
            const response = await fetch(process.env.REACT_APP_API_BASE_URL + 'billPayment/' + this.state.customerId + '/' + this.state.paymentId, requestParams);
            const data = await response.json();
            this.setState({
                billpaymentDetails: data.payload.billPaymentDetails.filter( p => p.billStatus !== 'Completed'),

            });
        } catch (err) {
            console.log("Error in " + this.displayName + ".getBillPaymentMaster function", err);
        }
    }
    onFocusedRowChanging =(e)=> {
        
        const rowsCount = e.component.getVisibleRows().length;
        const pageCount = e.component.pageCount();
        const pageIndex = e.component.pageIndex();
        const key = e.event && e.event.key;
    
        if (key && e.prevRowIndex === e.newRowIndex) {
          if (e.newRowIndex === rowsCount - 1 && pageIndex < pageCount - 1) {
            e.component.pageIndex(pageIndex + 1).done(() => {
              e.component.option('focusedRowIndex', 0);
            });
          } else if (e.newRowIndex === 0 && pageIndex > 0) {
            e.component.pageIndex(pageIndex - 1).done(() => {
              e.component.option('focusedRowIndex', rowsCount - 1);
            });
          }
        }
      }
      handleRowPrepared = (e) => {
        if (e.rowType === 'data') {
            
           let s = this.state.billpaymentDetails;
          s.map((x, index, array) => {
            if(e.dataIndex == array.length -1)
            {
                e.rowElement.style.backgroundColor = '#FFF9C4'
            }
           
        });
    }




        
    }
    render() {
        const renderGridTotalAmountCell = (data) => {
            return <div><small><i className={currencySymbolFormats.currencyFormat}></i></small>&nbsp;&nbsp;{parseFloat(data.value).toFixed(precisionFormats[2])}</div>;
        }

        return (
            <Fragment>
                <div>
                    <DataGrid
                        dataSource={this.state.billpaymentDetails}
                        keyExpr="id"
                        id='invoicepaymentList'
                        selection={{ mode: 'single' }}
                        columnsAutoWidth={false}
                        showColumnLines={true}
                        showRowLines={true}
                        showBorders={true}
                        rowAlternationEnabled={false}
                        allowColumnResizing={true}
                        onExporting={this.onExporting}
                        columnResizingMode='widget'
                        onRowPrepared={this.handleRowPrepared}
                       // onFocusedRowChanging={this.onFocusedRowChanging}
                        onToolbarPreparing={this.onToolbarPreparing}>
                        <Column dataField="poNumber" caption="PO#" allowSearch={true} allowFiltering={false} allowSorting={true} width={100} />
                        <Column dataField="billNo" caption="Bill#" allowSearch={true} allowFiltering={false} allowSorting={true} width={180} />
                        <Column dataField="billDate" caption="Bill Date" allowSearch={true} allowFiltering={false} allowSorting={true} width={200} dataType="datetime" format="dd/MM/yyyy" />
                        <Column dataField="grossAmount" caption="Bill Amount" allowSearch={true} allowFiltering={false} allowSorting={true} width={150} cellRender={renderGridTotalAmountCell} />
                        <Column dataField="settledDate" caption="Settle Date" allowSearch={true} allowFiltering={false} allowSorting={true} width={150} dataType="datetime" format="dd/MM/yyyy" />
                        <Column dataField="settledAmount" caption="Settle Amount" allowSearch={true} allowFiltering={false} allowSorting={true} width={150} cellRender={renderGridTotalAmountCell} />
                        <Column dataField="dueAmount" caption="Due Amount" allowSearch={true} allowFiltering={false} allowSorting={true} width={150} cellRender={renderGridTotalAmountCell} />
                        {/* <Column dataField="billStatus" caption="Status" allowSearch={true} allowFiltering={false} allowSorting={true} width={150} /> */}
                        <SortByGroupSummaryInfo summaryItem="count" />
                        <GroupPanel visible={false} />
                        {/* <Template name="toolbarTemplate" /> */}
                        <HeaderFilter visible={true} />
                        <SearchPanel visible={false} highlightCaseSensitive={true} width={240} placeholder="Search..." />
                        <Grouping autoExpandAll={true} />
                        {/* <Paging defaultPageSize={20} /> */}
                        <Pager showPageSizeSelector={false} allowedPageSizes={[10, 20, 50]} showInfo={false} visible={false} />
                        <Export enabled={false} allowExportSelectedData={false} fileName="InvoicePayment" />
                    </DataGrid>
                </div>
            </Fragment>
        );
    }
}

export default DetailTemplate;